// extracted by mini-css-extract-plugin
module.exports = {"pwa-button":"PWAButton__pwa-button__fGm65","pwaButton":"PWAButton__pwa-button__fGm65"};